import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import * as faceapi from 'face-api.js';
import LandingPage from './components/LandingPage';
import StudentView from './components/StudentView';
import AdminPanel from './components/AdminPanel';
import CreateExam from './components/CreateExam';

const App = () => {
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [loadingText, setLoadingText] = useState('Initializing...');

  useEffect(() => {
    let cancelled = false;
    const loadModels = async () => {
      try {
        setLoadingText('Loading AI Proctoring Models...');
        const URL = '/models';
        await faceapi.nets.tinyFaceDetector.loadFromUri(URL);
        await faceapi.nets.faceLandmark68Net.loadFromUri(URL);
        if (!cancelled) setModelsLoaded(true);
      } catch (err) {
        if (!cancelled) setLoadingText('ERROR: Failed to load AI models.');
        console.error(err);
      }
    };
    loadModels();
    return () => { cancelled = true; };
  }, []);

  if (!modelsLoaded) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #0a0a0a 100%)',
        color: '#fff',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 60, height: 60, border: '4px solid rgba(76,187,76,0.2)',
            borderTopColor: '#4cbb4c', borderRadius: '50%',
            animation: 'spin 1s linear infinite', margin: '0 auto 24px'
          }} />
          <h2 style={{ fontWeight: 400, fontSize: 20, color: '#aaa' }}>{loadingText}</h2>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/exam/:examId" element={<StudentView />} />
        <Route path="/admslfvmsfpjvpskvpin" element={<AdminPanel />} />
        <Route path="/admslfvmsfpjvpskvpin/create" element={<CreateExam />} />
      </Routes>
    </Router>
  );
};

export default App;
